var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useImperativeHandle, forwardRef } from 'react';
import { Grid } from '@antv/l7plot';
import useL7Plot from '../../hooks/useL7Plot';
import { getChart } from '../../util';
import ErrorBoundary from '../../errorBoundary';
import ChartLoading from '../../util/createLoading';
var GridMap = forwardRef(function (props, ref) {
    var chartRef = props.chartRef, _a = props.containerStyle, containerStyle = _a === void 0 ? {
        height: 'inherit',
    } : _a, className = props.className, loading = props.loading, loadingTemplate = props.loadingTemplate, errorTemplate = props.errorTemplate, config = __rest(props, ["chartRef", "containerStyle", "className", "loading", "loadingTemplate", "errorTemplate"]);
    var _b = useL7Plot(Grid, config), plotRef = _b.plotRef, containerRef = _b.containerRef;
    useEffect(function () {
        getChart(chartRef, plotRef.current);
    }, [plotRef.current]);
    useImperativeHandle(ref, function () { return ({
        getChart: function () { return plotRef.current; },
    }); });
    return (React.createElement(ErrorBoundary, { errorTemplate: errorTemplate },
        loading && React.createElement(ChartLoading, { loadingTemplate: loadingTemplate }),
        React.createElement("div", { className: className, style: containerStyle, ref: containerRef })));
});
export default GridMap;
